module.exports = __webpack_public_path__ + "img/05010011.a45ea1e7.jpg";